import { render, staticRenderFns } from "./loginvotacao.vue?vue&type=template&id=0c4dec04&scoped=true&"
import script from "./loginvotacao.vue?vue&type=script&lang=js&"
export * from "./loginvotacao.vue?vue&type=script&lang=js&"
import style0 from "./loginvotacao.vue?vue&type=style&index=0&id=0c4dec04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4dec04",
  null
  
)

export default component.exports